import React from "react"
import {
  DateTimePicker as MuiDateTimePicker,
  DateTimePickerProps,
} from "@mui/x-date-pickers/DateTimePicker"
import { TextField } from "@mui/material"
import { Dayjs } from "dayjs"

import { PartialBy } from "src/types/PartialBy"

type Props = PartialBy<DateTimePickerProps<Dayjs, Dayjs>, "renderInput">

export const DateTimePicker: React.FC<Props> = ({ value, onChange, renderInput, ...rest }) => (
  <MuiDateTimePicker
    value={value}
    onChange={onChange}
    renderInput={
      renderInput ? renderInput : (params) => <TextField {...params} variant="standard" />
    }
    {...rest}
  />
)
